import { DefaultState } from 'store/types';

export const GET_LODGING_REQUESTS_ALL_COUNT_DATA_REQUEST = 'GET_LODGING_REQUEST_ALL_COUNT_DATA_REQUEST';
export const GET_LODGING_REQUESTS_ALL_COUNT_DATA_SUCCESS = 'GET_LODGING_REQUEST_ALL_COUNT_DATA_SUCCESS';
export const GET_LODGING_REQUESTS_ALL_COUNT_DATA_FAILURE = 'GET_LODGING_REQUEST_ALL_COUNT_DATA_FAILURE';

export type GetLodgingRequestsAllCountState = DefaultState & {
  contents: number;
};

interface ReadGetLodgingRequestsAllCountDataRequest {
  type: typeof GET_LODGING_REQUESTS_ALL_COUNT_DATA_REQUEST;
};

interface ReadGetLodgingRequestsAllCountDataSuccess {
  type: typeof GET_LODGING_REQUESTS_ALL_COUNT_DATA_SUCCESS,
  contents: number;
}

interface ReadGetLodgingRequestsAllCountDataFailure {
  type: typeof GET_LODGING_REQUESTS_ALL_COUNT_DATA_FAILURE;
}

export type GetLodgingRequestsAllCountActionTypes = ReadGetLodgingRequestsAllCountDataRequest | ReadGetLodgingRequestsAllCountDataSuccess | ReadGetLodgingRequestsAllCountDataFailure;